import {
  Button,
  RefreshButton,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin'
import { useState } from 'react'
import { CircularProgress } from '@mui/material'

const DownloadButton = () => {
  const record = useRecordContext()
  const dp = useDataProvider()

  const handleClick = async () => {
    dp.downloadFileImport(record.id).then(({ data }) => {
      window.location.href = data.url
    })
  }

  return <Button label="Download" onClick={handleClick} />
}

const ImportButton = () => {
  const [loading, setLoading] = useState(false)
  const record = useRecordContext()
  const notify = useNotify()
  const dp = useDataProvider()
  const refresh = useRefresh()

  const handleClick = () => {
    setLoading(true)
    dp.startFileImport(record.id)
      .then(() => {
        notify('Import started')
        window.dispatchEvent(
          new CustomEvent('import-log-started', {
            detail: { id: record.id },
          })
        )
        refresh()
      })
      .catch((error) => {
        notify(`Import error: ${error.message}`, { type: 'warning' })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <Button label="Import" onClick={handleClick} />
      {loading && <CircularProgress size={24} />}
    </>
  )
}

const FileActionButtons = () => {
  return (
    <div className="flex">
      <DownloadButton />
      <ImportButton />
      <RefreshButton />
    </div>
  )
}

export default FileActionButtons
